import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { addDays, isAfter, isBefore, subDays } from 'date-fns'
import { IssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'

export function ShareSplitRow({ issue }: { issue: IssueEntity }) {
    const { t } = useTranslation()
    let shareSplitContent: ReactNode = null
    const publicationDate = issue.publicationDate ? new Date(issue.publicationDate) : null

    if (issue.shareSplits.length === 0 || !publicationDate) {
        return null
    }

    const outcomePm = issue.sources.find((source) => source.sourceType === 'Outcome')
    const endComparisonDateBase = outcomePm ? new Date(outcomePm.publishedDate) : publicationDate
    const startComparisonDate = subDays(publicationDate, 30)
    const endComparisonDate = addDays(endComparisonDateBase, 30)

    const shareSplitWithinTimeFrame = issue.shareSplits.find(
        (shareSplit) =>
            isAfter(new Date(shareSplit.changeDate), startComparisonDate) &&
            isBefore(new Date(shareSplit.changeDate), endComparisonDate),
    )

    if (shareSplitWithinTimeFrame) {
        const { changeDate, newShares, oldShares } = shareSplitWithinTimeFrame
        const oldSharesLabel = oldShares > 1 ? t('pages.issues.terms.shares') : t('pages.issues.terms.share')
        const newSharesLabel = newShares > 1 ? t('pages.issues.terms.shares') : t('pages.issues.terms.share')

        if (newShares > oldShares) {
            shareSplitContent = t('pages.issues.terms.shareSplitForward', {
                date: changeDate,
                oldShares,
                oldSharesLabel,
                newShares,
                newSharesLabel,
            })
        } else if (oldShares > newShares) {
            shareSplitContent = t('pages.issues.terms.shareConsolidation', {
                date: changeDate,
                oldShares,
                oldSharesLabel,
                newShares,
                newSharesLabel,
            })
        }
    }

    return shareSplitContent ? (
        <FactsTableRow label={t('pages.issues.terms.shareSplit')}>{shareSplitContent}</FactsTableRow>
    ) : null
}
